module.exports = __webpack_public_path__ + "static/img/1.6be541b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/eng/1.png
// module id = VAVS
// module chunks = 0